import BaseAPI from 'utils/api/base';

import { APIRequest } from 'utils/api/types';

import { env } from 'config';

import { TeamDetailsResponse, TeamAssignedUserResponse, TeamResponse } from './teams.types';

class TeamsAPI extends BaseAPI {
  loadTeamDetails = (teamId: string): APIRequest<TeamDetailsResponse> => {
    const url = `/teams/${teamId}/`;
    const method = 'GET';

    return this.request<TeamDetailsResponse>({
      url,
      method,
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });
  };

  createTeam = (data: { name: string; members: TeamAssignedUserResponse[] }): APIRequest<TeamResponse> => {
    const url = '/teams/';
    const method = 'POST';

    return this.request<TeamResponse>({
      url,
      method,
      data,
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });
  };

  updateTeam = (
    teamId: string,
    data: { name: string; members: TeamAssignedUserResponse[] }
  ): APIRequest<TeamDetailsResponse> => {
    const url = `/teams/${teamId}/`;
    const method = 'PATCH';

    return this.request<TeamDetailsResponse>({
      url,
      method,
      data,
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });
  };

  deleteTeam = (taskId: string): APIRequest<void> => {
    const method = 'DELETE';
    const url = `/teams/${taskId}/`;

    return this.request<void>({
      url,
      method,
      baseURL: env.REACT_APP_ADMIN_API_URL,
    });
  };
}

export default TeamsAPI;
